import { ClientLambdaApi } from '@/api-client.js'
import StockBreakGrid from '@/app/stock_break/models/Grid'
import { salesTwoRanges, downloadGridToXlsx, pivotSales } from '@/app/shared/Services.js'

const getRetailList = async () => {
  const stockBreakRetailSelector = {
    parameters: {
      store_dimensions: ['retail_name', 'retail_id'],
      metrics: {
        normal: ['stock_break_status'],
        var: []
      },
      fact: {
        type: 'table',
        name: 'dw_stock_break'
      },
      sort: {
        field: 'stock_break_status',
        dir: 'DESC'
      },
      limit: 0,
      offset: 0
    }
  }
  const retailList = await salesTwoRanges(stockBreakRetailSelector)
  return retailList.data
}

const downloadStockBreakToXlsx = async () => {
  const stockBreakExcelParameters = {
    parameters: {
      store_filters: {
        retail_id: []
      },
      product_dimensions: ['vendor_product_code', 'vendor_product_description', 'retail_product_description', 'retail_product_code'],
      store_dimensions: ['retail_name', 'retail_store_code', 'retail_store_name'],
      metrics: {
        normal: ['week_1', 'week_2', 'week_3', 'week_4', 'week_avg', 'woi', 'transfer_quantity', 'stock_quantity', 'stock_break_status', 'first_suggested', 'final_suggested', 'retail_suggested_condition'],
        var: []
      },
      fact: {
        type: 'table',
        name: 'dw_stock_break'
      },
      custom_response: 3,
      limit: 0,
      offset: 0
    }
  }
  await downloadGridToXlsx(stockBreakExcelParameters)
}

const getBreakProductsByRetailId = async (retailId, clientDimensionFilterKey) => {
  const stockBreakDimensionFilterParameters = {
    store_filters: {
      retail_id: [retailId]
    },
    product_dimensions: [clientDimensionFilterKey],
    store_dimensions: [],
    metrics: {
      normal: ['stock_break_status'],
      var: []
    },
    fact: {
      type: 'table',
      name: 'dw_stock_break'
    },
    sort: {
      field: 'stock_break_status',
      dir: 'desc'
    },
    limit: 0,
    offset: 0
  }

  const dimensionFilter = await ClientLambdaApi.post('/dimension-filter/', {
    parameters: stockBreakDimensionFilterParameters
  })
  return dimensionFilter.data
}

const getStockBreakGrid = async (retailId, productFilterFieldKey, productFilterFieldValue, storeIds) => {
  const stockBreakGridParameters = {
    parameters: {
      store_filters: {
        retail_id: [retailId],
        store_id: storeIds
      },
      product_dimensions: ['vendor_product'],
      product_filters: {
        [productFilterFieldKey]: [productFilterFieldValue]
      },
      store_dimensions: ['retail_store_name'],
      metrics: {
        normal: ['stock_break_status'],
        var: []
      },
      fact: {
        type: 'table',
        name: 'dw_stock_break'
      },
      limit: 0,
      offset: 0
    },
    pivotParameters: {
      index_dim: ['vendor_product'],
      column: 'retail_store_name'
    }
  }

  const stockBreakGrid = await pivotSales(stockBreakGridParameters)
  return new StockBreakGrid(stockBreakGrid)
}

const getRetailStoreList = async (retailId) => {
  const retailStorelistParameters = {
    parameters: {
      store_dimensions: ['store_id', 'retail_name_store_name'],
      metrics: {
        normal: ['stock_break_status'],
        var: []
      },
      fact: {
        type: 'table',
        name: 'dw_stock_break'
      },
      sort: {
        field: 'stock_break_status',
        dir: 'DESC'
      },
      limit: 0,
      offset: 0,
      store_filters: {
        retail_id: [retailId]
      }
    }
  }
  const retailStoreList = await salesTwoRanges(retailStorelistParameters)
  return retailStoreList.data
}

export {
  getRetailList,
  downloadStockBreakToXlsx,
  getBreakProductsByRetailId,
  getStockBreakGrid,
  getRetailStoreList
}



// WEBPACK FOOTER //
// ./src/app/stock_break/Services.js